import { render, staticRenderFns } from "./Organizers.vue?vue&type=template&id=4c3b0e0e&scoped=true&lang=pug&"
import script from "./Organizers.vue?vue&type=script&lang=js&"
export * from "./Organizers.vue?vue&type=script&lang=js&"
import style0 from "./Organizers.vue?vue&type=style&index=0&id=4c3b0e0e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3b0e0e",
  null
  
)

export default component.exports